/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/




export default {
    SET_SHIP_LIST(state, payload) {
        state.shipList = payload;
    },
    SET_ACTIVE_SHIP(state, payload) {
        state.activeShip = payload;
    },
    OPEN_CREATE_SHIP(state, payload) {
        state.createShip = payload;
    },
    OPEN_MENU_EDIT_MODAL(state, payload) {
        state.isMenuEdit = payload;
    },
    SET_SHIP_SEARCH(state, payload) {
        state.shipSearch = payload;
    },
    SET_SHIP_STATE_FILTER(state, payload) {
    state.shipStateFilter = payload;
    },
    SET_HIDE_MODAL(state, payload) {
        state.hideModal = payload;
    }
}